
import '../css/loader.css';
import '../App.css';
import '../css/privacy.css';
import { Link } from 'react-router-dom';

const How = () => {
  return (
    <div className="loader flex-center">
      <div className="do-stuff-box">
        <div className="input-area privacy">
          <h1>How it works</h1>
          <p>
            You choose a Google Sheet from Google Drive with the front/back card
            text in the first two columns, with a header row.{" "}
            <a href="https://docs.google.com/spreadsheets/d/1Z98n35AHupJOfxj6F2tIsSfHbLt6KuKGWFasvfFiqV4/edit#gid=0">
              Here&apos;s an example.
            </a>{" "}
            The app creates two additional hidden sheets in the spreadsheet,
            "history" and "params", to store your work. Look at the example - you'll 
            see you can use C and D to provide additional information. The app will 
            also create new columns A and B (it moves your data over) and writes to them. It uses a machine learning
            model running on your device to show you the right cards at the right time.
          </p>


          <section>
            <h2>How can I help?</h2>
            <p>
              Ideas, code, feature requests, and donations are always welcome. You
              can <a href="https://www.buymeacoffee.com/sifttrainer">buy me a coffee</a>,{" "}
              <a href="https://github.com/mchonofsky/flashcard-web-app">
                contribute on GitHub
              </a>
              , or{" "}
              <a href="https://www.markchonofsky.com">get in touch</a>.
            </p>
          </section>

          <Link className="privacy-back" to="/">
            Back to app
          </Link>
        </div>
      </div>
    </div>
  );
};

export default How;
